// extracted by mini-css-extract-plugin
module.exports = {"airplane":"airplane-3UYWS","airplane__name":"airplane__name-3SqFH","details":"details-2aKmc","sunInfo":"sunInfo-a3aQ_"};